import { Component } from '@angular/core';
import { ModalService } from '../../core/service/modal/modal.service';
import { AuthService } from '../../core/service/authentication/auth.service';
import {
  FormGroup,
  FormControl,
  Validators,
  ValidatorFn,
  ValidationErrors,
  AbstractControl,
} from '@angular/forms';
import { NotificationService } from '../../core/service/notifications/notification.service';
import { ApiResponseStatus } from '../../core/models/common/enums/api-response-status.enum';
import { ApiResponseErrorCodes } from '../../core/models/common/enums/api-response-error-codes.enum';

@Component({
  selector: 'app-register-modal',
  templateUrl: './register-modal.component.html',
  styleUrls: ['./register-modal.component.scss'],
})
export class RegisterModalComponent {

  isPasswordVisible = false
  isPasswordCVisible = false
  emailExists = false;

  regexValidator = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  registerForm: FormGroup = new FormGroup(
    {
      emailAddress: new FormControl('', [Validators.required, Validators.email, this.emailExistsValidator.bind(this)]),
      password: new FormControl('', {
        validators: [Validators.required, Validators.pattern(this.regexValidator)],
      }),
      confirmPassword: new FormControl('', {
        validators: [Validators.required, Validators.pattern(this.regexValidator)],
      }),
      acceptedTermsAndCondition: new FormControl(false, [Validators.required]),
    },
    {
      validators: [this.passwordMatchValidator()],
    }
  );

  constructor(
    private modalService: ModalService,
    private authService: AuthService,
    private notificationService: NotificationService
  ) { }

  openLoginModal() {
    this.modalService.openModal('login')
  }

  closeModal(): void {
    const modal = document.getElementById('login')
    if (modal) {
      modal.classList.remove('show');
    }
  }

  register(): void {
    this.authService.register(
      {
        emailAddress: this.registerForm.value.emailAddress,
      },
      this.registerForm.value.password
    ).subscribe({
      next: (response) => {
        if (response.status === ApiResponseStatus.Ok) {
          this.notificationService.showSuccess('A message has been sent to your email address. Please confirm it before start to use GoGo Money Maker.');
          this.emailExists = false;
          this.modalService.closeAllModals();
        }
      },
      error: (errorResponse) => {
        if (errorResponse.status === 409 ||
          errorResponse.error?.type === ApiResponseErrorCodes.AlreadyExistsUserWithSameEmail) {
          this.emailExists = true;
          this.registerForm.get('emailAddress')?.updateValueAndValidity();
        }
      }
    });
  }

  /*===== SHOW PSW EYE ========*/

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  togglePasswordCVisibility(): void {
    this.isPasswordCVisible = !this.isPasswordCVisible;
  }

  /*===== VALIDATORS ========*/

  passwordMatchValidator(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      const password = form.value.password;
      const confirmPassword = form.value.confirmPassword;

      if (password && confirmPassword && password !== confirmPassword) {
        return { passwordMismatch: true };
      }
      return null;
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emailExistsValidator(_control: AbstractControl): ValidationErrors | null {
    return this.emailExists ? { emailExists: true } : null;
  }
}
